export default __webpack_public_path__ + "static/media/wind.8e78ae4d.png";